import Scrollbar from 'src/components/Scrollbar';
import {
  Box,
  Drawer,
  alpha,
  styled,
  Divider,
  useTheme,
  lighten,
  darken,
  IconButton,
  Tooltip
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import SidebarMenu from './SidebarMenu';
import Logo from 'src/components/LogoSign';
import { useContext } from 'react';
import { SidebarContext } from 'src/contexts/SidebarContext';

const SidebarWrapper = styled(Box)(
  ({ theme }) => `
        width: ${theme.sidebar.width};
        min-width: ${theme.sidebar.width};
        color: ${theme.colors.alpha.trueWhite[70]};
        position: relative;
        z-index: 7;
        height: 100%;
        padding-bottom: 68px;
`
);

function Sidebar() {
  const theme = useTheme();
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
  const closeSidebar = () => toggleSidebar();

  return (
    <>
      {/* Permanent Sidebar for large screens */}
      <SidebarWrapper
        sx={{
          display: {
            xs: 'none',
            lg: 'inline-block'
          },
          position: 'fixed',
          left: 0,
          top: 0,
          background:
            theme.palette.mode === 'dark'
              ? alpha(lighten(theme.header.background, 0.1), 0.5)
              : darken(theme.colors.alpha.black[100], 0.5),
          boxShadow:
            theme.palette.mode === 'dark' ? theme.sidebar.boxShadow : 'none'
        }}
      >
        <Scrollbar>
          <Box mt={3}>
            <Box
              sx={{
                width: '100%',
                height: '100%'
              }}
            >
              <Logo />
            </Box>
          </Box>
          <Divider
            sx={{
              mt: theme.spacing(3),
              mx: theme.spacing(2),
              background: theme.colors.alpha.trueWhite[10]
            }}
          />
          <SidebarMenu />
        </Scrollbar>
        <Divider sx={{ background: theme.colors.alpha.trueWhite[10] }} />
      </SidebarWrapper>

      {/* Drawer Sidebar for small screens */}
      <Drawer
        sx={{
          boxShadow: `${theme.sidebar.boxShadow}`
        }}
        anchor={theme.direction === 'rtl' ? 'right' : 'left'}
        open={sidebarToggle}
        onClose={closeSidebar}
        variant="temporary"
        elevation={9}
      >
        <SidebarWrapper
          sx={{
            background:
              theme.palette.mode === 'dark'
                ? theme.colors.alpha.white[100]
                : darken(theme.colors.alpha.black[100], 0.5)
          }}
        >
          <Scrollbar>
            {/* Close Button */}
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              flexDirection="column"
              p={2}
            >
              <Box sx={{
                width: '100%',
                display: {
                  lg: 'none',
                  xs: 'flex'
                },
                justifyContent: 'flex-end'
              }}>
                <Tooltip
                  title={'Collapse'}
                  placement="bottom">
                  <IconButton
                    onClick={toggleSidebar}
                    sx={{
                      color: 'white',
                      transition: 'all 0.3s ease-in-out',
                      '&:hover': {
                        backgroundColor: 'rgba(255, 255, 255, 0.2)',
                        color: '#ff5252',
                        transform: 'scale(1.1)',
                      },
                    }}>
                    <CloseIcon />
                  </IconButton>
                </Tooltip>
              </Box>
              <Box>
                <Logo />
              </Box>
            </Box>
            <Divider
              sx={{
                mt: theme.spacing(3),
                mx: theme.spacing(2),
                background: theme.colors.alpha.trueWhite[10]
              }}
            />
            <SidebarMenu />
          </Scrollbar>
          <Divider
            sx={{
              background: theme.colors.alpha.trueWhite[10]
            }} />
        </SidebarWrapper>
      </Drawer>
    </>
  );
}

export default Sidebar;
